import React from 'react';
import { GlassCard } from '../../_shared/GlassCard';
import { TrendingUp, Calendar } from 'lucide-react';

const months = [
    {
        month: "January '26",
        views: '~1.24M',
        followers: '+5,183',
        status: 'High Profile Reach',
        statusColor: 'text-blue-400 bg-blue-500/15',
        gradient: 'from-blue-600/20 to-blue-800/5',
        borderColor: 'border-blue-500/20',
        highlight: false,
    },
    {
        month: "February '26",
        views: '~2.30M',
        followers: '+8,500',
        status: '+428.8% Peak Growth Spike',
        statusColor: 'text-emerald-400 bg-emerald-500/15',
        gradient: 'from-emerald-600/20 to-emerald-800/5',
        borderColor: 'border-emerald-500/20',
        highlight: false,
    },
    {
        month: "March '26",
        views: '753K',
        followers: '+4,001',
        status: '28 Reels Shared',
        statusColor: 'text-yellow-400 bg-yellow-500/15',
        gradient: 'from-yellow-600/20 to-yellow-800/5',
        borderColor: 'border-yellow-500/30 shadow-[0_0_40px_rgba(234,179,8,0.1)]',
        highlight: true,
    },
];

export const MonthlyTrajectory = () => {
    return (
        <section className="py-16 px-4">
            <div className="container mx-auto max-w-6xl">
                <h2 className="text-3xl md:text-5xl font-bold text-white mb-3 text-center">
                    Monthly Trajectory
                </h2>
                <p className="text-white/50 text-center mb-12 max-w-2xl mx-auto">
                    A month-by-month breakdown showing the growth arc from launch to scale.
                </p>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                    {months.map((m, i) => (
                        <GlassCard
                            key={i}
                            className={`relative overflow-hidden bg-gradient-to-br ${m.gradient} ${m.borderColor} ${m.highlight ? 'ring-1 ring-yellow-500/30' : ''}`}
                        >
                            {m.highlight && (
                                <div className="absolute top-3 right-3">
                                    <span className="bg-yellow-500/20 text-yellow-400 text-[10px] font-bold uppercase tracking-widest px-2 py-1 rounded-full border border-yellow-500/30">
                                        Latest
                                    </span>
                                </div>
                            )}

                            <div className="flex items-center gap-2 mb-6">
                                <Calendar size={16} className="text-white/40" />
                                <h3 className="text-lg font-bold text-white">{m.month}</h3>
                            </div>

                            <div className="space-y-5">
                                <div>
                                    <p className="text-white/40 text-xs uppercase tracking-widest font-semibold mb-1">Total Views</p>
                                    <p className="text-3xl font-black text-white">{m.views}</p>
                                </div>
                                <div>
                                    <p className="text-white/40 text-xs uppercase tracking-widest font-semibold mb-1">Followers Gained</p>
                                    <p className="text-2xl font-bold text-white">{m.followers}</p>
                                </div>
                            </div>

                            <div className="mt-6">
                                <span className={`inline-flex items-center gap-1.5 text-xs font-bold px-3 py-1.5 rounded-full ${m.statusColor}`}>
                                    <TrendingUp size={12} />
                                    {m.status}
                                </span>
                            </div>
                        </GlassCard>
                    ))}
                </div>
            </div>
        </section>
    );
};
